import React from 'react';

import { StyledFilterTypeBadge } from './styled';

import type { FilterType } from './button';

export function FilterTypeBadge({ filterType }: { filterType: FilterType }) {
  return <StyledFilterTypeBadge $type={filterType}>{filterType}</StyledFilterTypeBadge>;
}
